require('../../modules/es6.array.find');
module.exports = require('../../modules/_core').Array.find;



//////////////////
// WEBPACK FOOTER
// F:/Solutions/6713ge/master/~/core-js/fn/array/find.js
// module id = 184
// module chunks = 1